import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class InvitesService {

  constructor(private http: HttpClient) { }
  invitation(body) {
    return this.http.post<ApiResponseModel>('/api/invitation', body);
  }
  invitationExist(body) {
    return this.http.get<ApiResponseModel>('/api/invitation?token=' + body);
  }
  getAllInvites() {
    return this.http.get<ApiResponseModel>('api/invitation/list');
  }
  resendInvite(body) {
    return this.http.post<ApiResponseModel>('api/invitation/resend', body);
  }
}
